<template>
    <div id="copyright">
        <span> <i class="fab fa-vuejs"></i> <i class="fab fa-html5"></i> <i class="fab fa-css3-alt"></i> <i class="fab fa-bootstrap"></i>  Copyright © Jallalla 2021 </span>
    </div>
</template>

<script>
export default {
    name:"Copyright",
}
</script>

<style>

#copyright{
    padding: 12px;
    background: rgb(252,103,103);
background: linear-gradient(210deg, rgba(252,103,103,1) 0%, rgba(163,0,57,1) 100%);
    margin-bottom: 0px;
}
</style>